import Vue from 'vue';
import Router from 'vue-router';
import { getToken, removeToken, checkTokenExpired } from './assets/js/utils/auth'; // 封装 token 工具函数

Vue.use(Router);

let router = new Router({
  mode: "history", //1、hash哈希：有#号。2、history历史：没有#号
  base: process.env.BASE_URL, //自动获取根目录路径
  scrollBehavior: (to, from, position) => {
    if (position) {
      return position
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  },
  routes: [{
    path: "/",
    name: "index",
    component: () => import("./pages/index/index")
  },
  {
    path: "/login",
    name: "login",
    component: () => import("./pages/login/login")
  },
  {
    path: "/search",
    name: "search",
    component: () => import("./pages/index/search")
  },
  {
    path: "/register",
    name: "register",
    component: () => import("./pages/register/register")
  },
  {
    path: "/bidding",
    name: "bidding",
    component: () => import("./pages/bidding/bidding")
  },
  {
    path: "/regulation",
    name: "regulation",
    component: () => import("./pages/regulation/regulation")
  },
  {
    path: "/platform",
    name: "platform",
    component: () => import("./pages/platform/platform")
  },
  {
    path: "/download",
    name: "download",
    component: () => import("./pages/download/download")
  },
  {
    path: "/about",
    name: "about",
    component: () => import("./pages/about/about")
  },
  {
    path: "/help",
    name: "help",
    component: () => import("./pages/help/help")
  },
  {
    path: "/channel",
    name: "channel",
    component: () => import("./pages/channel/channel")
  },
  {
    path: "/message",
    name: "message",
    component: () => import("./pages/index/message")
  }
  ]
});
router.beforeEach((to, from, next) => {
  // console.log('路由跳转前守卫:', to.path, from.path, 'token:', getToken());
  if (to.path === '/login') {
    next();
    return;
  }

  const token = getToken();
  if (token) {
    // 情况 1：已登录，检查 token 是否有效（可选，根据业务需求）
    // 例如：如果 token 有过期时间，需要校验是否过期
    const isTokenExpired = checkTokenExpired(); // 自定义过期校验函数
    if (isTokenExpired) {
      // token 过期，清除本地存储并跳转到登录页
      removeToken();
      if (to.path === '/platform') {
        return next({ path: '/login', query: { redirect: to.fullPath } }); // 记录目标路由
      }
    }
    // 情况 2：token 有效，允许访问
    next();
  } else {
    next();
  }
});
export default router;
